<template>
  <div class="">
    <accordion-product-wrapper
                               :is-open="isOpen" :product_id="product_id"
                               :products="item.products"
                               :label="item.name"
                               :desc="item.description"
                               v-for="item in productCategories" v-if="item.products.length > 0" :key="item.id">
    </accordion-product-wrapper>
  </div>
</template>

<script>
import TabProducts from './components/TabProducts'
import AccordionProductWrapper from './components/AccordionProductWrapper'

export default{
  props: {
    restaurant_id: {
      Type: String
    },
    product_id : {
      type: String
    },
    isOpen: Number
  },
  mounted () {
    this.getProductList()
  },
  beforeCreate () {
    this.$store.commit('api/SET_PRODUCT_CATEGORIES_LIST', null)
  },
  computed: {
    productCategories () {
      return this.$store.state.api.productCategories
    }
  },
  watch: {
  },
  beforeDestroy () {
  },
  methods: {

    getProductList () {

      this.$vs.loading()

      // Loading
      const payload = {
        restaurantId: this.restaurant_id
      }

      this.$store.dispatch('api/getProductList', payload)
        .then(() => {

          this.mergeProducts(this.productCategories)
          this.$vs.loading.close()
          this.showTabs = true
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-F-circle',
            color: 'danger'
          })
        })

    },
    mergeProducts (categories) {
      const list = []
      categories.map(function (value) {
        value.products.map(function (value_) {
          list.push(value_)
        })
      })
      this.data_list = list
    }
  },
  components: {
    TabProducts,
    AccordionProductWrapper
  },
  data () {
    return {
      data_list: [],
      showTabs: false
    }
  }
}
</script>

<style lang="scss">
.items-grid-view {
  .col-padding {
    padding: 0;
  }
}
</style>
